import { render, staticRenderFns } from "./ProductPriceList.vue?vue&type=template&id=000f8ccc&scoped=true&"
import script from "./ProductPriceList.vue?vue&type=script&lang=js&"
export * from "./ProductPriceList.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceList.vue?vue&type=style&index=0&id=000f8ccc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000f8ccc",
  null
  
)

export default component.exports